import React from 'react'

const OrderManagement = () => {
  return (
    <div>OrderManagement</div>
  )
}

export default OrderManagement